module.exports = __webpack_public_path__ + "static/atlas-hero-background-90a55747ef5540795bc7ccb689b23f2a.webp";